import type { CreatedComponent } from '../../common/model/types.tsx';
import type { ComponentResponse } from '../../common/rest/types.tsx';

export const transformComponent = (component: ComponentResponse): CreatedComponent => {
	const { id, name, self } = component;
	return {
		id,
		name,
		self,
	};
};
